import React from 'react';
import { View, ImagePropTypes, TouchableWithoutFeedback } from 'react-native'

import memoize from 'memoize-one';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { Icon } from '../Icon';
import { Images, useTheme } from '../Themes';
import VFText from '../VFText';

import styles from './VFWheelSelector.Styles';
import WheelSelector from './WheelSelector';


const _getItemStyle = (currentIndex, selectedIndex) => {
  // const theme = useTheme();
  switch (selectedIndex) {
    case currentIndex:
      return styles.selectedWheelItem
    case currentIndex - 1:
    case currentIndex + 1:
      return styles.nearestWheelItem;
    default:
      return styles.farWheelItem;
  }
};

const _getIconStyles = (currentIndex, selectedIndex) => {
  switch (selectedIndex) {
    case currentIndex:
      return {
        size: 33,
        style: {
          marginTop: 3,
          opacity: 1,
        },
      };
    case currentIndex - 1:
    case currentIndex + 1:
      return {
        size: 24,
        style: {
          opacity: 0.4,
        },
      };
    default:
      return {
        size: 20,
        style: {
          opacity: 0.2,
        },
      };
  }
};

const _getItemStyleMemoized = memoize(_getItemStyle);
const _getIconStylesMemoized = memoize(_getIconStyles);

const renderGiftIcon = (data, index, selectedIndex, singleValue, giftIcon) => {
  if (data.gift) {
    return (
      <View style={styles.itemsStyle}>
        <Icon
          type="image"
          name={giftIcon || Images.ic_rewards}
          size={_getIconStylesMemoized(index, selectedIndex).size}
          style={_getIconStylesMemoized(index, selectedIndex).style}
          accessibilityLabel={FoundationTestKeys.TPMainGiftIcon}
        />
      </View>
    );
  } else if (!singleValue) {
    return <View style={styles.itemsStyle} />;
  }
};

const VFWheelSelector = ({
  wheelValues,
  singleValue,
  currency,
  onValueChange,
  renderItem,
  giftIcon,
  currencyAccessibilityLabel,
  defaultSelectedIndex,
  isCurrencyFirst,
}) => {
  return (
    <View style={styles.container(singleValue, isCurrencyFirst)}>
      <WheelSelector
        singleValue={singleValue}
        giftIcon={giftIcon}
        dataSource={wheelValues}
        currency={currency}
        selectedIndex={defaultSelectedIndex}
        itemHeight={50}
        wrapperHeight={singleValue ? 50 : 250}
        renderItem={renderItem}
        onValueChange={onValueChange}
        currencyAccessibilityLabel={currencyAccessibilityLabel}
        isCurrencyFirst={isCurrencyFirst}
      />
    </View>
  );
};

VFWheelSelector.defaultProps = {
  renderItem: (data, index, selectedIndex, singleValue, giftIcon, onPress) => {
    const item = (
      <View style={styles.wheelStyle}>
        {renderGiftIcon(data, index, selectedIndex, singleValue, giftIcon)}
        <View style={styles.itemsStyle}>
          <VFText
            style={_getItemStyleMemoized(index, selectedIndex)}
            testID={FoundationTestKeys.TPAmountSum}
            localize={false}
            i18nKey={data.value}
          />
        </View>
      </View>
    );
    return item;
  },
  onValueChange: () => { },
  wheelValues: [],
  isCurrencyFirst: false,
};

VFWheelSelector.propTypes = {
  singleValue: PropTypes.bool,
  wheelValues: PropTypes.array.isRequired,
  currency: PropTypes.string,
  onValueChange: PropTypes.func,
  renderItem: PropTypes.func,
  giftIcon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  currencyAccessibilityLabel: PropTypes.string,
  defaultSelectedIndex: PropTypes.number,
  isCurrencyFirst: PropTypes.bool,
};
export default VFWheelSelector;
